import * as z from "zod/v4";
import { EbayListingIdWithStatusSchema } from "../marketplace/ebay-listing";
import { ListingType } from "./base-listing";
import { ChatGptListingIdWithStatusSchema } from "./chatgpt-listing/chatgpt-listing";
import { RedoMarketplaceListingIdWithStatusSchema } from "./redo-marketplace-listing/redo-marketplace-listing";
import { ShopifyListingIdWithStatusSchema } from "./shopify-listing/shopify-listing";

export const ListingStatusSchema = {
  [ListingType.Shopify]: ShopifyListingIdWithStatusSchema.nullable(),
  [ListingType.ChatGpt]: ChatGptListingIdWithStatusSchema.nullable(),
  [ListingType.RedoMarketplace]:
    RedoMarketplaceListingIdWithStatusSchema.nullable(),
  [ListingType.Ebay]: EbayListingIdWithStatusSchema.nullable(),
  [ListingType.General]: z.null(),
  [ListingType.Amazon]: z.null(),
  [ListingType.Walmart]: z.null(),
  [ListingType.Perplexity]: z.null(),
};

export type ListingStatusType = {
  [key in ListingType]: (typeof ListingStatusSchema)[key] extends z.ZodType<
    infer T
  >
    ? T
    : never;
};

export type ListingStatus = {
  [key in ListingType]: ListingStatusType[key];
};

export const ListingsWithStatusSchema = z.object({
  ...ListingStatusSchema,
});
export type ListingsWithStatus = z.infer<typeof ListingsWithStatusSchema>;
